module.exports = "/assets/data/1c972290c1f720e593d9caa75bf3b439-CA8.data.json";